import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { useLDFlag } from '@/data/LD/selectors/getLDFlag';
import { usePrevious } from '@/shared/hooks/usePrevious';
import { useWiwDispatch } from '@/store';
import { TwilioProvider } from '@/workchat/v2/providers//TwilioProvider';
import { StreamProvider } from '@/workchat/v2/providers/StreamProvider';
import { reset } from '@/workchat/v2/store/reducer';

export const WorkChatProvider = ({ children }: PropsWithChildren<any>) => {
  const dispatch = useWiwDispatch();

  const isStreamEnabled = useLDFlag('fdt-1167-work-chat-stream-migration');
  const prevIsStreamEnabled = usePrevious(isStreamEnabled);

  useEffect(() => {
    if (prevIsStreamEnabled !== isStreamEnabled) {
      dispatch(reset(true));
    }
  }, [dispatch, prevIsStreamEnabled, isStreamEnabled]);

  if (isStreamEnabled) {
    return <StreamProvider>{children}</StreamProvider>;
  }

  return <TwilioProvider>{children}</TwilioProvider>;
};
